import type { HTMLAttributes, ReactNode } from "react";

interface LiveMessageProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  tone?: "status" | "alert";
  visuallyHidden?: boolean;
}

export function LiveMessage({
  children,
  tone = "status",
  visuallyHidden = false,
  className = "",
  ...props
}: LiveMessageProps) {
  const liveAttributes =
    tone === "alert"
      ? { role: "alert" as const, "aria-live": "assertive" as const }
      : { role: "status" as const, "aria-live": "polite" as const };

  const visibilityClass = visuallyHidden ? "sr-only" : "";

  return (
    <div
      aria-atomic="true"
      className={`${visibilityClass} ${className}`.trim()}
      {...liveAttributes}
      {...props}
    >
      {children}
    </div>
  );
}
